import src from "IMAGE";
export default { src, width: 117, height: 68, blurWidth: 0, blurHeight: 0};
